import formatTableJson from '@younuo/config/tableComponentParams.js'
export default formatTableJson([
  {
    filed: 'nickName',
    label: '昵称'
  },
  {
    filed: 'phone',
    label: '手机号'
  },
  {
    filed: 'mobileType',
    label: '手机系统',
    formatFn: function (_, row) {
      let dic = {
        android: 'Android',
        ios: 'iOS'
      }
      return dic[row.mobileType] ? dic[row.mobileType] : '--'
    }
  },
  {
    filed: 'appVersion',
    label: 'APP版本'
  },
  {
    filed: 'createTime',
    label: '注册时间',
    type: 'time',
    width: '170'
  },
  {
    filed: 'lastLoginTime',
    label: '最近登录时间',
    type: 'time',
    width: '170'
  }
])
